export function isoDateLocal(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function currentMonthDateRange(): { from: string; to: string } {
  const now = new Date()
  const start = new Date(now.getFullYear(), now.getMonth(), 1)
  return { from: isoDateLocal(start), to: isoDateLocal(now) }
}

type RemittanceExportRow = {
  staffName: string
  email?: string | null
  cashTotal: string
  transferTotal: string
}

type RemittanceExportData = {
  storeName?: string
  storeId?: number
  from?: string
  to?: string
  totals?: { cash?: string; transfer?: string }
  byStaff?: RemittanceExportRow[]
}

function csvCell(value: unknown): string {
  return `"${String(value ?? '').replace(/"/g, '""')}"`
}

export function downloadRemittanceCsv(data: RemittanceExportData): void {
  const lines: string[] = [
    ['Store', data.storeName ?? '', 'Store ID', data.storeId ?? ''].map(csvCell).join(','),
    ['From', data.from ?? '', 'To', data.to ?? ''].map(csvCell).join(','),
    ['Cash total', data.totals?.cash ?? '', 'Transfer total', data.totals?.transfer ?? '']
      .map(csvCell)
      .join(','),
    '',
    ['Staff name', 'Email', 'Cash total', 'Transfer total'].map(csvCell).join(','),
    ...(data.byStaff ?? []).map((row) =>
      [row.staffName, row.email ?? '', row.cashTotal, row.transferTotal].map(csvCell).join(','),
    ),
  ]

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = `pos-remittance-store-${data.storeId ?? 'export'}-${data.from ?? 'from'}-to-${data.to ?? 'to'}.csv`
  anchor.click()
  URL.revokeObjectURL(url)
}
